import { Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { romie, ROMIE_BOLD_WEIGHT } from '@/styles/fonts/romie';
import { TITLE_SERIF_SIZING } from '@/styles/tokens/fonts';

/** Questions-ready content shared by the setup overview and its review preview. */
export function SetupValidationPrompt({
  householdName,
  onAnswer,
  initialSetup = false,
  disabled = false,
}: {
  householdName: string;
  onAnswer: () => void;
  initialSetup?: boolean;
  disabled?: boolean;
}) {
  return (
    <Stack spacing={2} alignItems="flex-start" sx={{ maxWidth: 740 }}>
      <Typography
        variant="h1_display"
        component="h2"
        sx={{
          fontFamily: romie.style.fontFamily,
          fontWeight: ROMIE_BOLD_WEIGHT,
          ...TITLE_SERIF_SIZING[initialSetup ? 'xl' : 'l'],
        }}
      >
        A few facts to confirm before the {householdName} household{' '}
        {initialSetup ? 'is complete.' : 'can be updated.'}
      </Typography>
      <Typography variant="body-m">
        The documents don’t settle these questions. We want to ensure the client
        profile is {initialSetup ? 'built' : 'updated'} accurately.
        {initialSetup && ' Your deliverables will be created after.'}
      </Typography>
      <Button
        variant="primary"
        size="md"
        onClick={onAnswer}
        disabled={disabled}
      >
        Answer validation questions
      </Button>
    </Stack>
  );
}
